import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { VideosViewComponent } from './videos-view.component';
import { PhutureIavatarModule } from '../@components/phuture-iavatar/phuture-iavatar.module';

@NgModule({
  declarations: [VideosViewComponent],
  imports: [CommonModule, FormsModule, PhutureIavatarModule],
  exports: [VideosViewComponent],
})
export class VideosViewModule {}
